import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const EventTableSkeleton = ({ rows, columns, height = 15 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <tr key={index} className="w-100">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex}>
              <div className="row d-flex justify-content-between align-items-end">
                <div className="col-8">
                  <div className="mb-1">
                    <Skeleton width={"70%"} height={height} />
                  </div>
                  <Skeleton width={"30%"} height={7} />
                </div>
                <div className="col-4 text-end">
                  <Skeleton width={"15%"} height={7} />
                </div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
EventTableSkeleton.propTypes = {
  rows: PropTypes.any,
  columns: PropTypes.any,
  height: PropTypes.any
};
export default EventTableSkeleton;
